import React from 'react';
import { AvTooltip } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { Box, Button, capitalize } from '@mui/material';
import { APP_PATHS, AppPathKey } from '../types';
import { appsOptions } from './newNavigation/appbar.constants';

interface Props {
  apps: AppPathKey[];
}
export const AppIcon = ({ app }) => {
  const { iconFull, name } = appsOptions.find(({ enumValue }) => enumValue === app)!;
  return (
    <AvTooltip
      title={capitalize(name)}
      key={name}
      muiProps={{ placement: 'top' }}
      popperProps={{ modifiers: [{ name: 'offset', options: { offset: [2, -8] } }] }}>
      <Button>
        <Box sx={{ borderRadius: '8px', ...flex.center }}>{iconFull}</Box>
      </Button>
    </AvTooltip>
  );
};

const AvAppTag: React.FC<Props> = ({ apps }) => (
  <Box sx={{ ...flex.itemsCenter, gap: 1, whiteSpace: 'nowrap' }}>
    {apps.map(app => {
      const { iconFull, name } = appsOptions.find(({ id }) => id === APP_PATHS[app])!;
      return (
        <Box key={app} sx={theme => generateSx(theme)}>
          <Box sx={{ borderRadius: '8px', ...flex.center }}>{iconFull}</Box>
          <span>{name}</span>
        </Box>
      );
    })}
  </Box>
);

const generateSx = theme => ({
  background: 'rgba(238, 238, 243, 1)',
  pr: '8px',
  ...flex.itemsCenter,
  gap: 1,
  fontSize: 13,
  fontWeight: 600,
  height: '22px',
  borderRadius: '8px',
  color: theme.palette.colors.neutrals[650],
});

export default AvAppTag;
